(() => {
  const KEY = "solave-favorites-v1";
  const dialog = document.getElementById("sv-favorites-dialog");
  const list = dialog?.querySelector("[data-sv-favorites-list]");
  const empty = dialog?.querySelector("[data-sv-favorites-empty]");
  const send = dialog?.querySelector("[data-sv-favorites-send]");
  const close = dialog?.querySelector("[data-sv-favorites-close]");

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || "[]");
      return Array.isArray(value) ? value.filter(item => item && item.id && item.url) : [];
    } catch (_) {
      return [];
    }
  };

  const write = items => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (_) {}
  };

  const buttons = () => document.querySelectorAll("[data-sv-favorite-button]");
  const updateButton = (button, items) => {
    const saved = items.some(item => String(item.id) === String(button.dataset.svFavoriteId));
    button.classList.toggle("is-saved", saved);
    button.setAttribute("aria-pressed", String(saved));
    const label = saved ? button.dataset.svFavoriteRemoveLabel : button.dataset.svFavoriteAddLabel;
    if (label) button.setAttribute("aria-label", label);
    const hiddenLabel = button.querySelector("[data-sv-favorite-label]");
    if (hiddenLabel && label) hiddenLabel.textContent = label;
  };

  const updateAll = items => {
    buttons().forEach(button => updateButton(button, items));
    document.querySelectorAll("[data-sv-favorites-count]").forEach(count => {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
    });
  };

  const render = () => {
    if (!dialog || !list || !empty || !send) return;
    const items = read();
    list.replaceChildren();
    empty.hidden = items.length > 0;
    send.hidden = items.length === 0;

    items.forEach(item => {
      const row = document.createElement("article");
      row.className = "sv-favorite-item";
      const link = document.createElement("a");
      link.className = "sv-favorite-item__link";
      link.href = item.url;

      if (item.image) {
        const image = document.createElement("img");
        image.src = item.image;
        image.alt = "";
        image.loading = "lazy";
        link.append(image);
      }

      const detail = document.createElement("span");
      detail.className = "sv-favorite-item__details";
      const title = document.createElement("strong");
      title.textContent = item.title || "";
      detail.append(title);
      if (item.price) {
        const price = document.createElement("span");
        price.textContent = item.price;
        detail.append(price);
      }
      link.append(detail);

      const remove = document.createElement("button");
      remove.type = "button";
      remove.className = "sv-favorite-item__remove";
      remove.textContent = dialog.dataset.svFavoriteRemoveLabel || "Odebrat";
      remove.setAttribute("aria-label", remove.textContent + ": " + (item.title || ""));
      remove.dataset.svFavoriteRemove = item.id;
      row.append(link, remove);
      list.append(row);
    });

    const message = [
      "Ahoj, chci se zeptat na dostupnost a cenu těchto párů:",
      "",
      ...items.flatMap(item => ["• " + (item.title || "Pár"), item.url, ""])
    ].join("\n");
    send.href = "https://wa.me/420608972154?text=" + encodeURIComponent(message);
    updateAll(items);
  };

  const openDialog = () => {
    if (!dialog) return;
    render();
    if (!dialog.open) dialog.showModal();
  };

  document.addEventListener("click", event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const favorite = target.closest("[data-sv-favorite-button]");
    if (favorite) {
      event.preventDefault();
      event.stopPropagation();
      const items = read();
      const id = String(favorite.dataset.svFavoriteId || "");
      const existing = items.findIndex(item => String(item.id) === id);

      if (existing >= 0) {
        items.splice(existing, 1);
      } else {
        items.push({
          id,
          title: favorite.dataset.svFavoriteTitle || "",
          url: favorite.dataset.svFavoriteUrl || "",
          image: favorite.dataset.svFavoriteImage || "",
          price: favorite.dataset.svFavoritePrice || ""
        });
      }
      write(items);
      updateAll(items);
      if (dialog?.open) render();
      return;
    }

    if (target.closest("[data-sv-favorites-trigger]")) {
      event.preventDefault();
      openDialog();
      return;
    }

    const remove = target.closest("[data-sv-favorite-remove]");
    if (remove) {
      event.preventDefault();
      const id = String(remove.dataset.svFavoriteRemove);
      const items = read().filter(item => String(item.id) !== id);
      write(items);
      render();
      return;
    }

    if (target.closest("[data-sv-favorites-close]")) dialog?.close();
  }, true);

  close?.addEventListener("click", () => dialog?.close());
  dialog?.addEventListener("click", event => {
    if (event.target === dialog) dialog.close();
  });
  window.addEventListener("storage", event => {
    if (event.key === KEY) render();
  });

  updateAll(read());
})();
